/* eslint-disable import/no-anonymous-default-export */
import { exeRequest } from '../utils/APIUtils';

export default {
    getUserInfo: async () => (await exeRequest("/users/me", "GET")).data,

    signin: async (data) => {
        const resultat = await exeRequest("/login", "POST", data);
        // console.log("Résultat de la connexion:", resultat);
        return resultat;
    },

    listeDesAdministrateurs: async () => await exeRequest("/admin/administrateurs", "GET"),

    getPermissions: async () => await exeRequest("/admin/permissions", "GET"),
    getRolePresets: async () => await exeRequest("/admin/role-presets", "GET"),

    miseAjourRoleEtPermissions: async (id, data) =>exeRequest(`/admin/update-role-permissions/${id}`, "PUT", data),

    getAdministrateurById: async (id) => exeRequest(`/admin/administrateurs/${id}`, "GET"),

    enregistrerUnAdministrateur: async (data) => exeRequest(`/admin/enregistrer-admin`, "POST", data),

    deleteAdministrateur: async (id) => exeRequest(`/admin/administrateur/${id}`, "DELETE"),

    miseAjourProfileAdmin: async (id, data) => exeRequest(`/admin/update-profile/${id}`, "PUT", data),

    // Réinitialiser le mot de passe d'un administrateur à 123456
    resetPassword: async (id) => exeRequest(`/admin/administrateur/${id}/reset-password`, "PATCH"),

};